import { useTranslation } from 'react-i18next'
import { ReactComponent as IconOrderFailure } from './assets/order-failure.svg'
import { ReactComponent as IconOrderSuccess } from './assets/order-success.svg'
import FullPageModal from '~/components/FullPageModal'
import { updateLimitOrderSubmitStatus } from '~/state/dex/actions'
import { useLimitOrderSubmitStatus, useLimitSwapPair } from '~/state/dex/hooks'
import { LimitOrderSubmitStatus } from '~/state/dex/type'
import { useAppDispatch } from '~/state/hooks'
import {
  BackButton,
  ModalContent,
  ModalContentWrapper,
  ModalTitle,
} from './styled'
import LottieLoading from '~/components/LottieLoading'
import { useEffect } from 'react'
import { lockBody } from '~/utils/lockBody'

const StatusMapIcon = {
  [LimitOrderSubmitStatus.Idle]: null,
  [LimitOrderSubmitStatus.SignOrderPending]: LottieLoading,
  [LimitOrderSubmitStatus.SignOrderSuccess]: IconOrderSuccess,
  [LimitOrderSubmitStatus.SignOrderFailure]: IconOrderFailure,

  [LimitOrderSubmitStatus.CancelOrderPending]: LottieLoading,
  [LimitOrderSubmitStatus.CancelOrderSuccess]: IconOrderSuccess,
  [LimitOrderSubmitStatus.CancelOrderFailure]: IconOrderFailure,
  [LimitOrderSubmitStatus.CancelOrderRejected]: IconOrderFailure,
}

const StatusMapI18n = {
  [LimitOrderSubmitStatus.Idle]: '',
  [LimitOrderSubmitStatus.SignOrderPending]: 'sign_order_pending',
  [LimitOrderSubmitStatus.SignOrderSuccess]: 'sign_order_success',
  [LimitOrderSubmitStatus.SignOrderFailure]: 'sign_order_failure',

  [LimitOrderSubmitStatus.CancelOrderPending]: 'cancel_order_pending',
  [LimitOrderSubmitStatus.CancelOrderSuccess]: 'cancel_order_success',
  [LimitOrderSubmitStatus.CancelOrderFailure]: 'cancel_order_failure',
  [LimitOrderSubmitStatus.CancelOrderRejected]: 'sign_order_failure',
}

const OrderStatus: React.FC = () => {
  const { t } = useTranslation()
  const status = useLimitOrderSubmitStatus()
  const [inputToken] = useLimitSwapPair()
  const inProgress = [
    LimitOrderSubmitStatus.SignOrderPending,
    LimitOrderSubmitStatus.CancelOrderPending,
  ].includes(status)
  const dispatch = useAppDispatch()

  const onClose = () => {
    dispatch(updateLimitOrderSubmitStatus(LimitOrderSubmitStatus.Idle))
  }

  useEffect(() => {
    lockBody(status !== LimitOrderSubmitStatus.Idle)
  }, [status])

  if (status === LimitOrderSubmitStatus.Idle) return null

  const StatusIcon = StatusMapIcon[status] || IconOrderFailure

  return (
    <FullPageModal showClose={false} visible={Boolean(status)}>
      <ModalContentWrapper>
        <ModalTitle>{t('authorize_order')}</ModalTitle>
        <ModalContent>
          <div className="status-img">{<StatusIcon />}</div>
          <p>
            {t(StatusMapI18n[status] || status, {
              inputTokenSymbol: inputToken?.symbol,
            })}
          </p>

          {!inProgress && (
            <BackButton onClick={onClose}>{t('back')}</BackButton>
          )}
        </ModalContent>
      </ModalContentWrapper>
    </FullPageModal>
  )
}

export default OrderStatus
